<template>
  <div class="invest-order-detail" :class="{'isiOSX':isiOSX}">
    <van-nav-bar class="invest-title" :fixed="true" title="订单详情"/>
    <img class="invest-reback" @click="prev" src="../../assets/myInvest/reback.png">
    <van-row class="detailes">
      <van-col class="detailes_" span="24">
        <div class="detailes_l" :style="imgH">
          <img :src="info.project.poster" @error="nofind()" v-if="info.project">
        </div>
        <div class="detailes_r">
          <div class="detailes_g" v-if="!info.refund">
            <span class="detailes_title" v-if="info.project">{{info.project.project_name}}</span>
            <span class="nopay close" v-if="info.status == -1">已关闭</span>
	          <span class="nopay" v-if="info.status == 1">待付款</span>
	          <span class="item-tips nopay" v-if="info.status == 2">正参与</span>
	          <span class="item-tips nopay" v-if="info.status == -2">已退款</span>
          </div>
          <div class="detailes_g" v-if="info.refund">
            <span class="detailes_title" v-if="info.project">{{info.project.project_name}}</span>
	          <span class="nopay" v-if="info.refund.status == 1">退款申请中</span>
	          <span class="nopay" v-if="info.refund.status == 2">待退款</span>
	          <span class="nopay" v-if="info.refund.status == 3">退款中</span>
	          <span class="nopay" v-if="info.refund.status == 4">已退款</span>
	          <span class="nopay" v-if="info.refund.status == -1">申请驳回</span>
	          <span class="nopay" v-if="info.refund.status == -2">审核驳回</span>
	          <span class="nopay" v-if="info.refund.status == -3">退款失败</span>
          </div>
          <div class="detailes_num">股数：{{info.shares}}股 每股单价：¥<span v-if="info.project">{{info.project.share_price}}</span></div>
        </div>
      </van-col>
      <van-col span="24" class="concrete">
        <div class="border-top-bottom">
          <p>订单编号：{{info.ordersn}}</p>
          <p v-if="info.status == 1">创建时间：{{info.created_at}}</p>
          <p v-if="info.status != 1 && info.status != -1">下单时间：{{info.pay_time}}</p>
          <p v-if="info.status == -1">关闭时间：{{info.cancel_time}}</p>
          <p v-if="info.status != 1 && info.status != -1">付款时间：{{info.pay_time}}</p>
          <div v-if="info.refund">
	          <p>退款申请：{{info.refund.created_at}}</p>
	          <p v-if="info.refund.status == 2 || info.refund.status == 3 || info.refund.status == 4">同意退股：{{info.refund.first_audit_time}}</p>
	          <p v-if="info.refund.status == 3 || info.refund.status == 4">进行退款：{{info.refund.second_audit_time}}</p>
	          <p v-if="info.refund.status == 4">退款完成：{{info.refund.complete_time}}</p>
	          <p v-if="info.refund.status == -1 || info.refund.status == -2">拒绝时间：{{info.refund.first_audit_time}}</p>
          </div>
        </div>
      </van-col>
      <van-col span="24" class="payfor" v-if="info.status != -1">
        <span v-if="info.status == 1">需付款：</span>
        <span v-if="info.status != 1 && !info.refund">实付款：</span>
        
        <span v-if="info.refund">退款金额：</span>
        <span v-if="info.price">¥{{info.price.split('.')[0]}}.</span><span class="zero" v-if="info.price">{{info.price.split('.')[1]}}</span>
      </van-col>
    </van-row>
    <van-row class="bottom-btn" v-if="info.status == 1">
      <van-col span="24" class="btn">
        <span class="cancel" @click="showPopup()">取消订单</span>
		<span class="pay" @click="investPay()">立即付款</span>
      </van-col>
    </van-row>
    <van-popup v-model="show">
    	<div class="box">
    		<img src="../../assets/common/BG@2x.png" alt="" />
    		<p class="title">温馨提示</p>
    		<p class="tips">亲，您真的要取消该订单吗？</p>
    		<span class="left" @click="cancle()">取消</span>
    		<span class="right" @click="confirm()">确认</span>
    	</div>
    </van-popup>
  </div>
</template>
<script>
import defaultImg from '@/assets/common/compare.png';
export default {
	data() {
	    return {
	    	imgH: {height: (document.body.clientWidth - 44) * 0.2915 * 0.7467 + 'px'},
				info: {},
	    	show: false,
	    	ordersn: '',
	    	isiOSX: false,
	    	orderInfo: {},
	    	cancleOrderSn: ''
	    };
	},
	created() {
  	this.isiOSX = this.isIphoneX();
		this.ordersn = this.$route.query.ordersn;
	　this.getInfo();
	},
	methods: {
		getInfo() {
			this.$api.post("/order/member/order/detail", {ordersn: this.ordersn, order: {type: 'investment'}}).then(res => {
		        this.info = res.list_extend;
		        res.main_order.ordersn = this.ordersn;
		        this.orderInfo = JSON.stringify(res.main_order);
		    });
		},
		prev() {
			this.$router.go(-1);
		},
		showPopup() {
		      this.show = true;
		      this.cancleOrderSn = this.info.ordersn;
	    },
	  	cancle() {
	    	this.show = false;
	    },
	  	confirm() {
	  		this.show = false;
	  		this.$api.post("/order/member/order/cancel", {ordersn: this.cancleOrderSn}).then(res => {
		        this.getInfo();
//		        this.info.status = -1;
	        });
	  	},
//	  	Pay() {
//	  		this.investPay();
//	  	},
	  	investPay() {
	  		this.params(this.orderInfo, this.orderInfo, 'investPay');
	    },
	  	nofind() {
		    var img = event.srcElement;
			img.src = defaultImg;
			img.onerror = null; //防止闪图
		}
	}
};
</script>
<style lang="less" scoped>
.invest-order-detail {
  background-color: #f2f2f2;
  position: relative;
  min-height: 100%;
  .invest {
	  &-title {
	  	z-index: 2 !important;
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	  }
	  &-reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 29px;
	    left: 0;
	    z-index: 2;
	  }
	}
  .detailes {
    background-color: #fff;
    padding-top: 69px;
    .detailes_ {
      display: flex;
      padding: 16px 16px 16px 16px;
      .detailes_l {
        width: 29.15%;
        height: auto;
        background: #f5f5f5;
        img {
          background: #F5F5F5;
          width: 100%;
          height: 100%;
        	border-radius: 3px;
        }
      }
      .detailes_r {
        margin-left: 12px;
        width: 70.85%;
        .detailes_g {
          display: flex;
          justify-content: space-between;
          .detailes_title {
            width: 140px;
            height: 48px;
            font-size: 16px;
            color: #333333;
            line-height: 24px;
            font-weight: 500;
            overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						white-space: normal;
          }
          .nopay {
            font-size: 14px;
            color: #c49e80;
            font-weight: 400;
            line-height: 20px;
          }
          .close {
          	color: #999;
          }
        }
        .detailes_num {
          margin-top: 11px;
          font-size: 13px;
          color: #999999;
          font-weight: 400;
          line-height: 17px;
        }
      }
    }
    .concrete {
      padding: 0 16px;
      .border-top-bottom {
        padding: 9px 0;
        border-top: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
        p {
          font-size: 13px;
          color: #999999;
          line-height: 22px;
        }
      }
    }
    .payfor {
      padding: 0 16px;
      font-size: 13px;
      color: #999999;
      line-height: 18px;
      margin-top: 13px;
      margin-bottom: 12px;
      span {
        font-size: 16px;
        color: #d29a6e;
      }
      .zero {
        font-size: 12px;
      }
    }
  }
  .bottom-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    .btn {
      display: flex;
      justify-content: flex-end;
      padding: 0 12px;
      margin-top: 10px;
      margin-bottom: 11px;
      span {
        width: 72px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 14px;
        font-size: 14px;
        color: #999999;
      }
      .cancel {
        border: 1px solid #979797;
        margin-right: 12px;
      }
      .pay {
        border: 1px solid #d29a6e;
        color: #d29a6e;
      }
    }
  }
  	.van-popup--center{
		width: 70%;
		border-radius: 10px;
		.box {
			img {
				display: block;
				width: 100%;
			}
			.title {
				color: #333;
				font-size: 15px;
				font-weight: 600;
				line-height: 47px;
				margin-top: 8px;
				text-align: center;
			}
			.tips {
				color: #333;
				font-size: 13px;
				line-height: 18px;
				text-align: center;
				margin-bottom: 30px;
			}
			span {
				float: left;
				width: 50%;
				border-top: solid 1px #F2F2F2;
				line-height: 43px;
				color: #999;
				font-size: 14px;
				text-align: center;
				display: inline-block;
			}
			.right {
				color: #E6212F;
				width: calc(50% - 1px);
				border-left: solid 1px #F2F2F2;
			}
		}
	}
}
.isiOSX {
	.invest {
	  &-title {
	    padding-top: 44px;
	  }
	  &-reback {
	    top: 45px;
	  }
	}
	.detailes {
    padding-top: 88px;
	}
}
</style>


